import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ProviderAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ProviderAuthProvider({ children }) {
  const [providerUser, setProviderUser] = useState(null);
  const [providerToken, setProviderToken] = useState(localStorage.getItem('meridian_provider_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (providerToken) {
      axios.get(`${API}/provider/auth/me`, { headers: { Authorization: `Bearer ${providerToken}` } })
        .then(res => setProviderUser(res.data))
        .catch(() => { localStorage.removeItem('meridian_provider_token'); setProviderToken(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [providerToken]);

  const providerLogin = async (email, password) => {
    const res = await axios.post(`${API}/provider/auth/login`, { email, password });
    localStorage.setItem('meridian_provider_token', res.data.token);
    setProviderToken(res.data.token);
    setProviderUser(res.data.provider_user);
    return res.data;
  };

  const providerRegister = async (email, password, claim_code) => {
    const res = await axios.post(`${API}/provider/auth/register`, { email, password, claim_code });
    return res.data;
  };

  const providerLogout = () => {
    localStorage.removeItem('meridian_provider_token');
    setProviderToken(null);
    setProviderUser(null);
  };

  const providerAuthHeaders = providerToken ? { Authorization: `Bearer ${providerToken}` } : {};

  return (
    <ProviderAuthContext.Provider value={{ providerUser, providerToken, loading, providerLogin, providerRegister, providerLogout, providerAuthHeaders }}>
      {children}
    </ProviderAuthContext.Provider>
  );
}

export const useProviderAuth = () => useContext(ProviderAuthContext);
